<template>
  <div>
    <b-row class="m-0">
        <b-col class="p-0">
        <fieldset class="border p-3">
            <legend  class="w-auto bg-facebook px-2 py-1 text-white rounded border h6">Employment Status  <font-awesome-icon icon="plus-circle" class="ml-3 cursor-pointer" @click="employment_status_modal=true" /></legend>
                <table class="table table-bordered mt-2 mb-0 table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col">Employment Status</th>
                            <th scope="col" class="text-center">Effective Date</th>
                            <th scope="col" class="text-center">Remarks</th>
                            <th scope="col" class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody class="bg-white text-dark">
                        <tr v-for="(manpower_employment_status_log, index) in params.form.manpower_employment_status_logs">
                            <td>
                                <strong>{{manpower_employment_status_log.employment_status.description}}</strong> <template v-if="manpower_employment_status_log.is_active"> | <b-badge variant="success">active</b-badge></template>
                            </td>
                            <td class="text-center">
                                {{manpower_employment_status_log.effective_date_formatted.other_formats.format_1}}
                            </td>
                            <td>
                                {{manpower_employment_status_log.remarks}}
                            </td>
                            <td class="text-center">
                                <b-button size="sm" variant="danger" @click="deleteEmploymentStatus(manpower_employment_status_log.id)"><font-awesome-icon icon="minus-circle" /> Remove</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>


            <fieldset class="border p-3 mt-3 bg-light">
                <legend  class="w-auto bg-facebook px-2 py-1 text-white rounded border h6">Job Title  <font-awesome-icon icon="plus-circle" class="ml-3 cursor-pointer" @click="job_description_modal=true" /></legend>
                <table class="table table-bordered mt-2 mb-0 table-sm">
                    <thead class="thead-dark">
                    <tr>
                        <th scope="col">Job Title</th>
                        <th scope="col" class="text-center">Monthly Rate</th>
                        <th scope="col" class="text-center">Daily Rate</th>
                        <th scope="col" class="text-center">Effective Date</th>
                        <th scope="col" class="text-center">Remarks</th>
                        <th scope="col" class="text-center">Action</th>
                    </tr>
                    </thead>
                    <tbody class="bg-white text-dark">
                    <tr v-for="(manpower_job_history_log, index) in params.form.manpower_job_history_logs">
                        <td>
                            <strong>{{manpower_job_history_log.manpower_job_description.description}}</strong> <template v-if="manpower_job_history_log.is_active"> | <b-badge variant="success">active</b-badge></template>

                        </td>
                        <td class="text-center">
                            <number-format-component :input_value="Number(manpower_job_history_log.monthly_rate)"/>
                        </td>
                        <td class="text-center">
                            <number-format-component :input_value="Number(manpower_job_history_log.daily_rate)"/>
                        </td>
                        <td class="text-center">
                            {{manpower_job_history_log.effective_date_formatted.other_formats.format_1}}
                        </td>
                        <td class="text-center">
                            {{manpower_job_history_log.remarks}}
                        </td>
                        <td class="text-center">
                            <b-button size="sm" variant="danger" @click="deleteJobDescription(manpower_job_history_log.id)"><font-awesome-icon icon="minus-circle" /> Remove</b-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </fieldset>


            <fieldset class="border p-3 mt-3">
                <legend  class="w-auto bg-facebook px-2 py-1 text-white rounded border h6">Leave Credits  <font-awesome-icon icon="plus-circle" class="ml-3 cursor-pointer" @click="leave_credit_modal=true" /></legend>
                <table class="table table-bordered mt-2 mb-0 table-sm">
                    <thead class="thead-dark">
                    <tr>
                        <th scope="col">Job Title</th>
                        <th scope="col" class="text-center">Effective Date</th>
                        <th scope="col" class="text-center">Yearly Credits</th>
                        <th scope="col" class="text-center">Used</th>
                        <th scope="col" class="text-center">Credit/s Left</th>
                        <th scope="col" class="text-center">Remarks</th>
                        <th scope="col" class="text-center">Action</th>
                    </tr>
                    </thead>
                    <tbody class="bg-white text-dark">
                    <tr v-for="(manpower_leave_benefit, index) in params.form.manpower_leave_benefits">
                        <td>
                            <strong>{{manpower_leave_benefit.leave_benefit.description}}</strong>

                        </td>
                        <td class="text-center">
                            {{manpower_leave_benefit.effective_date_formatted.other_formats.format_1}}
                        </td>
                        <td class="text-center">
                            {{manpower_leave_benefit.yearly_credits}}
                        </td>
                        <td class="text-center">
                            {{manpower_leave_benefit.yearly_credits - manpower_leave_benefit.leave_balance_credits}}
                        </td>
                        <td class="text-center">
                            {{manpower_leave_benefit.leave_balance_credits}}
                        </td>
                        <td class="text-center">
                            {{manpower_leave_benefit.remarks}}
                        </td>
                        <td class="text-center">
                            <b-button size="sm" variant="danger" @click="deleteLeaveCredit(manpower_leave_benefit.id)"><font-awesome-icon icon="minus-circle" /> Remove</b-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </fieldset>
        </b-col>
    </b-row>

      <b-modal v-model="employment_status_modal" centered size="md" body-class="p-0" :hide-footer="true" :hide-header="true">
          <employment-status-form @save="save"/>
      </b-modal>
      <b-modal v-model="job_description_modal" centered size="md" body-class="p-0" :hide-footer="true" :hide-header="true">
          <job-description-form @save="save"/>
      </b-modal>
      <b-modal v-model="leave_credit_modal" centered size="md" body-class="p-0" :hide-footer="true" :hide-header="true">
          <leave-credit-form @save="save"/>
      </b-modal>
  </div>
</template>
<script>

    import SwalMixin from "@/views/mixins/Swal.js";
    import SocialMediaForm from './SocialMediaForm.vue';
    import EmploymentStatusForm from './EmploymentStatusForm.vue';
    import JobDescriptionForm from './JobDescriptionForm.vue';
    import LeaveCreditForm from './LeaveCreditForm.vue';
    import NumberFormatComponent from '@/views/helpers/NumberFormatComponent.vue';
    export default {
        mixins:[SwalMixin],
        components: {NumberFormatComponent,SocialMediaForm,EmploymentStatusForm,JobDescriptionForm,LeaveCreditForm},
        props:{
            params: {
                type: Object,
                default: {},
                required: true
            },
        },
        data() {
            return {
                employment_status_modal:false,
                job_description_modal:false,
                leave_credit_modal:false
            }
        },
        methods:{
            deleteEmploymentStatus(id){
                this.swalConfirmDelete((data)=>{
                    if (data.value) {
                        this.is_saving=true;
                        this.axios.delete('maintenance/manpowers/employment-statuses/delete',{ data: {id:id} }).then(response => {
                            this.swalTransactionCompleted();
                            this.is_saving=false;
                            this.$emit('save');
                        }).catch(error => {
                            this.swal_transaction_error_data.text = error.response.data;
                            this.swalRequestError();
                            this.is_saving=false;
                        });
                    }
                });

            },
            deleteJobDescription(id){
                this.swalConfirmDelete((data)=>{
                    if (data.value) {
                        this.is_saving=true;
                        this.axios.delete('maintenance/manpowers/job-descriptions/delete',{ data: {id:id} }).then(response => {
                            this.swalTransactionCompleted();
                            this.is_saving=false;
                            this.$emit('save');
                        }).catch(error => {
                            this.swal_transaction_error_data.text = error.response.data;
                            this.swalRequestError();
                            this.is_saving=false;
                        });
                    }
                });

            },
            deleteLeaveCredit(id){
                this.swalConfirmDelete((data)=>{
                    if (data.value) {
                        this.is_saving=true;
                        this.axios.delete('maintenance/manpowers/leave-benefits/delete',{ data: {id:id} }).then(response => {
                            this.swalTransactionCompleted();
                            this.is_saving=false;
                            this.$emit('save');
                        }).catch(error => {
                            this.swal_transaction_error_data.text = error.response.data;
                            this.swalRequestError();
                            this.is_saving=false;
                        });
                    }
                });

            },
            save(){
                this.$emit('save');
                this.employment_status_modal=false;
                this.job_description_modal=false;
                this.leave_credit_modal=false;
            },
        }
    }
</script>
